class Product {
  constructor() {
      this.bindInit();
  }
  bindInit() {
    this.orderDatePopup();
    this.productTabs();
  }

  orderDatePopup() {
    const orderDateContainer = document.querySelector('.js-popup-container');
    const OrderDateLink = document.querySelector('.js-popup');
    const closePopup = document.querySelector('.js-close')

    OrderDateLink.addEventListener("click", () => {
      orderDateContainer.classList.add('is-active');
    });

    closePopup.addEventListener("click", () => {
      orderDateContainer.classList.remove('is-active');
    })
  }

  productTabs() {
    const tabContent = document.querySelectorAll(".js-tab-description");
    const tabTitle = document.querySelectorAll(".js-tab-link");

    tabTitle.forEach(getTabTitle => {
        getTabTitle.addEventListener("click", () => {
          tabContent.forEach(gettabContent => {
              if (gettabContent.getAttribute('data-value') === getTabTitle.getAttribute('data-value')) {
                  gettabContent.classList.toggle('is-active');
              } else {
                gettabContent.classList.remove('is-active');
              }
          });

          tabTitle.forEach(listTabTitle => {
            if (listTabTitle.getAttribute('data-value') === getTabTitle.getAttribute('data-value')) {
              listTabTitle.classList.toggle('is-active');
            } else {
              listTabTitle.classList.remove('is-active');
            }
          });
        });
    });
  }


}

new Product();
